import { Box } from '@mui/material';
import MuiBreadcrumbs from 'app/design/uiComponents/MuiBreadcrumbs';
import { PageTitleBackVariant, PageTitleWithChipWithValueVariant } from '.';
import { PageTitlePaperTestingVariantProps } from '../types';
import { useGetMediaQueryUp } from 'app/hooks/useGetMediaQuery';

const PageTitlePaperTestingVariant = ({
  title,
  value,
  chipProps,
  buttonText,
  buttonHandleClick,
  breadcrumbLinks,
  breadcrumb,
}: PageTitlePaperTestingVariantProps) => {
  const isMdUp = useGetMediaQueryUp('md');
  return (
    <Box>
      {!isMdUp ? (
        <PageTitleBackVariant
          buttonText={buttonText}
          buttonHandleClick={buttonHandleClick}
        />
      ) : breadcrumb !== undefined ? (
        <Box className="m-main-spacing" sx={{ pt: 3, pb: 0 }}>
          {breadcrumb}
        </Box>
      ) : (
        <Box className="m-main-spacing" sx={{ pt: 3, pb: 0 }}>
          <MuiBreadcrumbs links={breadcrumbLinks!} />
        </Box>
      )}
      <PageTitleWithChipWithValueVariant
        title={title}
        value={value}
        chipProps={chipProps}
      />
    </Box>
  );
};

export default PageTitlePaperTestingVariant;
